import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "course-top"
};
const _hoisted_2 = {
  class: "course-title text-overflow"
};
const _hoisted_3 = {
  class: "course-des"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "text-overflow"
};
const _hoisted_6 = {
  class: "course-bottom"
};
const _hoisted_7 = {
  class: "tag-list"
};
const _hoisted_8 = {
  class: "dataCount"
};
const _hoisted_9 = {
  class: "look"
};
const _hoisted_10 = {
  class: "quote"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    target: "_self",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleLink && $options.handleLink(...args)),
    class: "course-card card-hover",
    style: _normalizeStyle({
      backgroundColor: $data.backgroundColorList[$options.coverIndex]
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.courseData.case_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [$props.courseData.course_name ? (_openBlock(), _createElementBlock("span", _hoisted_4, "《" + _toDisplayString($props.courseData.course_name) + "》", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, _toDisplayString($props.courseData.realname) + "｜" + _toDisplayString($props.courseData.organ_name), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.ideologyNameList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "tag-item",
      key: index
    }, " #" + _toDisplayString(item), 1);
  }), 128))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[1] || (_cache[1] = _createTextVNode(" 查看 ")), _createElementVNode("span", null, _toDisplayString($props.courseData.showCount), 1)]), _cache[3] || (_cache[3] = _createElementVNode("div", null, "|", -1)), _createElementVNode("div", _hoisted_10, [_cache[2] || (_cache[2] = _createTextVNode(" 引用 ")), _createElementVNode("span", null, _toDisplayString($props.courseData.quote_num), 1)])])])], 4);
}